var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_10373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.844 16.5887C30.8056 16.5609 30.7632 16.5397 30.7168 16.5251L11.3067 8.78227C11.133 8.71465 10.9354 8.75575 10.8015 8.88436C10.6663 9.01429 10.6212 9.21051 10.6809 9.38684L13.2159 16.9706L10.6809 24.5543C10.6212 24.7306 10.6663 24.9268 10.8015 25.0568C10.9354 25.1854 11.133 25.2265 11.3067 25.1589L30.7168 17.416C30.8785 17.3551 30.9965 17.2105 31.0217 17.0395C31.0495 16.8685 30.9806 16.6961 30.844 16.5887ZM28.0545 16.4933L14.0538 16.4933L11.9112 10.0657L28.0545 16.4933ZM28.0545 17.4479L11.9112 23.8755L14.0538 17.4479L28.0545 17.4479Z",
    fill: "#EE6D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_10373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.9706) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ed994ffe3784048f42fd4e15137e30a8.svg";
export { ForwardRef as ReactComponent };